export const BUTTON_ID = 'fuel-availability-button';

export const FUEL = ['DIESEL', 'AI92', 'AI95', 'AI98_100'] as const;

export type FuelType = (typeof FUEL)[number];

export const DEFAULT_AVAILABILITY = 'ALL' as const;

export const RESTRICTION_AVAILABILITY = 'Restrictions' as const;

export const AVAILABLE_AVAILABILITY = 'Available' as const;

export const AVAILABILITY = [
  DEFAULT_AVAILABILITY,
  RESTRICTION_AVAILABILITY,
  AVAILABLE_AVAILABILITY,
] as const;

export const DEFAULT_AVAILABILITY_STATUS = 'available' as const;

export const AVAILABILITY_STATUS = [
  DEFAULT_AVAILABILITY_STATUS,
  'probably_unavailable',
] as const;

export type AvailabilityType = (typeof AVAILABILITY)[number];
export type AvailabilityStatusType = (typeof AVAILABILITY_STATUS)[number];
